import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import VideoPopup from "../../components/common/VideoPopup/VideoPopup";
import LookingTodoNext from "../../components/landing/LookingTodoNext/LookingTodoNext";
import HEADER from "../../components/nbhd/header/NbhdContentHeader";
import MAP from "../../components/nbhd/map/InitMap/InitMap";
import PinLegend from "../../components/nbhd/map/PinLegend/PinLegend";
import POI from "../../components/nbhd/POI/POI";
import Search from "../../components/nbhd/search/Search";
import ViewPOI from "../../components/nbhd/viewpoi/ViewPOI";
import { RESET_POI_VIEW_DATA } from "../../redux/actionTypes/actionsTypes";
import "./NBHDLanding.css";
import ReactGA from "react-ga4";
import { marketPulseEnabled } from "../../utils/configs";
import { isAmppa } from "../../utils/isAmppa";

export interface NBHDComponentProps {
    handleViewChange: (e) => void
}

export default function NBHDLanding(): JSX.Element {
    const { t } = useTranslation(["nbhd"]);
    // eslint-disable-next-line
    const [childComponents, setChildComponents] = useState([{ name: "SEARCH", translation: "search", img: "images/Search.png" }, { name: "POI", translation: "properties-of-interest", img: "images/FavouriteList.png" }])
    const [childComponent, setChildComponent] = useState("POI");
    const [viewComponent, setViewComponent] = useState("MAP");
    const [viewModal, setViewModal] = useState(false);

    const [subPropCoord, setSubPropCoord] = useState<Array<number>>([0, 0]);

    const [subPropMun, setSubPropMun] = useState<string>("");

    const [reportLoading, setReportLoading] = useState(false);
    
    const videoSrc = localStorage.getItem("prefLang") === "en" ? "https://www.youtube.com/embed/_Y89mmtFNwg" : "https://www.youtube.com/embed/zaHYsBcXnZE";

    const dispatch = useDispatch();

    const handleChildComponentChange = (name: string) => {
        ReactGA.send({ hitType: "pageview", page: "amp/nbhd", title: name })
        setChildComponent(name);
    };

    const handleViewChange = (name: string) => {
        if(name === "ViewPOI") {
            dispatch({ type: RESET_POI_VIEW_DATA });
        } else if(name === "MAP") {
            setReportLoading(false);
        }
        ReactGA.send({ hitType: "pageview", page: "amp/nbhd", title: name })
        setViewComponent(name);
    };

    const toggleModal = () => {
        setViewModal(!viewModal);
    };

    const directToPulse = () => {
        const url = process.env?.REACT_APP_MARKET_PULSE_PATH;
        ReactGA.event({
            category: "Market Pulse",
            action: "Market Pulse Clicked",
            label: `Market Pulse Clicked`, // optional
        });
        if (isAmppa){
            window.open(url, '_blank').focus();
        } else {
            ReactGA.send({ hitType: "pageview", page: "the-market-pulse-ui/" })
            window.open(`https://${window.location.hostname}/${url}`, '_blank').focus();
        }
        
    }

    return (
        <>
            <div className="NBHD-page">
                <div className="NBHD-desc">
                    <div className="NBHD-landing">
                        <h1>{t("nbhd.landing.title1")}</h1>
                        <p>{t("nbhd.landing.content-1-1")}</p>
                        <p>{t("nbhd.landing.content-1-2")}</p>
                        <p>{t("nbhd.landing.content-1-3")}</p>
                        <ul>
                            <li>{t("nbhd.landing.content-2-1")}</li>
                            <li>{t("nbhd.landing.content-2-2")}</li>
                            <li>{t("nbhd.landing.content-2-3")}</li>
                            <li>{t("nbhd.landing.content-2-4")}</li>
                            <li>{t("nbhd.landing.content-2-5")}</li>
                            <li>{t("nbhd.landing.content-2-6")}</li>
                        </ul>


                    </div>
                    <div className="external-links-nbhd">
                        <div className="NBHD-tutorial" onClick={toggleModal}>
                            <div className="ampv4-tut-img">
                                <img src="images/Tutorial.png" alt="tutorial icon"></img>
                            </div>
                            <h3>
                                {t("nbhd.landing.title2")}
                                <br></br>
                                {t("nbhd.landing.title1")}
                            </h3>
                        </div>
                        {marketPulseEnabled && (
                            <div className="NBHD-tutorial" onClick={directToPulse}>
                                <div className="ampv4-tut-img">
                                    <img src="images/PropertyPulseDash.png" alt="pulse icon" ></img>
                                </div>
                                <h3>
                                    {t("nbhd.landing.title3")}
                                    <br></br>
                                    {t("nbhd.landing.title4")}
                                </h3>
                            </div>
                        )}
                    </div>
                </div>
                <div id='myneigh_content'>
                    <div className="row disable-swiper" >
                        <div className='neighbourhood-main-content'>
                            <div className="control-column">
                                <div className="nbhd-nav-parent">

                                    {childComponents.map((e: { name: string; translation: string; img: string; }, i: React.Key) => {
                                        return <div className={
                                            "nbhd-nav " +
                                            (childComponent === e.name ? "active" : "")
                                        }
                                            onClick={() =>
                                                handleChildComponentChange(e.name)
                                            }
                                            key={i}
                                        >
                                            <div
                                                className="amp-anchor nbhd-nav-text"
                                            >
                                                <img className="ampv4-img-esm-neighbourhood ampv4-img-esm-neighbourhood-white" src={t(e.img) as string} alt=''></img>
                                                {t("nbhd.nbhd-nav." + e.translation) as string}
                                            </div>
                                        </div>
                                    })}
                                </div>
                                
                                {/* Keeping the components rendered to save api calls */}
                                <div className={childComponent === "SEARCH" ? "" : "hidden"}>
                                    <Search subPropCoord={subPropCoord} subPropMun={subPropMun} handleViewChange={handleViewChange}/>
                                </div>
                                <div className={childComponent === "POI" ? "" : "hidden"}>
                                    <POI />
                                </div>
                                
                                
                            </div>
                            <div className="neihboiurhood-map-content">
                                <HEADER handleViewChange={handleViewChange} reportLoading={reportLoading}/>
                                <div className={viewComponent === "MAP" ? "" : "hidden"}>
                                    <MAP setSubPropCoord={setSubPropCoord} setSubPropMun={setSubPropMun}/>
                                    <PinLegend/>
                                </div>
                                <div className={viewComponent === "ViewPOI" ? "" : "hidden"}>
                                    {viewComponent === "ViewPOI" && <ViewPOI handleViewChange={handleViewChange} setReportLoading={setReportLoading}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-bar-container">
                <LookingTodoNext boxes={["rfr", "haw"]} />
            </div>
            {viewModal && <VideoPopup 
            toggleModal={toggleModal} 
            videoSrc={videoSrc}
            title={"Browse My Neighbourhood Tutorial"} />}
        </>
    );
}